import React from 'react';
import { RadioButton, RadioButtonProps } from 'ncoded-component-library';
import { FieldRenderProps } from 'react-final-form';
import classNames from 'classnames';

type RadioButtonFieldProps = FieldRenderProps<string, HTMLElement> & {
  className?: string;
  styled?: boolean;
  customOnChange?: (value: string) => void;
} & Omit<RadioButtonProps, 'name'>;

const RadioButtonField: React.FC<RadioButtonFieldProps> = (props) => {
  const {
    className,
    input: { onChange, ...restInput },
    meta,
    styled,
    customOnChange,
    ...rest
  } = props;

  return (
    <RadioButton
      className={classNames(className, { 'radio-button--styled': styled })}
      onChange={(e) => {
        onChange(e);
        customOnChange?.(e.target.value);
      }}
      {...restInput}
      {...rest}
    />
  );
};

export default RadioButtonField;
